import { render, staticRenderFns } from "./kdxPageComponent.g.vue?vue&type=template&id=175c62c4&scoped=true"
import script from "./kdxPageComponent.g.vue?vue&type=script&lang=js"
export * from "./kdxPageComponent.g.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175c62c4",
  null
  
)

export default component.exports